import style from "./dashboardCardShimmer.module.scss";
const DashboardCardShimmer = () => {
  return (
    <div className="pro-w-100">
      <div className={`pro-p-5 ${style.shimmer_container}`}>
        <div className="pro-d-flex pro-justify-between pro-items-start">
          <div className="pro-d-flex pro-flex-column pro-items-start">
            <div className="pro-pb-5 pro-pt-1 pro-ps-6 pro-pe-2 shimmer"></div>
            <div className="pro-py-1 pro-pt-2 pro-px-6 shimmer pro-mt-3"></div>
          </div>
          <div className="pro-px-4 pro-py-4 shimmer pro-rounded-3"></div>
        </div>
        <div className="pro-mt-4 pro-pt-4 pro-d-flex pro-items-end">
          <div className="pro-py-2 pro-px-5 shimmer pro-rounded-3"></div>
          <div className="pro-pb-3 pro-ps-6 pro-ms-3 shimmer"></div>
        </div>
      </div>
    </div>
  );
};

export default DashboardCardShimmer;
